import React from 'react';
import type { UnitDefinition, SeatingUnit } from '@/types/seating-v2.types';
import { UnitRenderer } from '../UnitRenderer';

interface SingleArrangementProps {
  unit: UnitDefinition;
  units: SeatingUnit[];
  selectedSeat: number | null;
  onSeatClick: (globalSeatNumber: number) => void;
  onSeatDrop: (globalSeatNumber: number, guestId: number) => void;
}

/**
 * Renders a single centered unit (for boardroom-style layouts).
 */
export const SingleArrangement: React.FC<SingleArrangementProps> = ({
  unit,
  units,
  selectedSeat,
  onSeatClick,
  onSeatDrop,
}) => {
  if (units.length === 0) return null;

  const u = units[0];

  return (
    <div className="flex items-center justify-center p-8">
      <UnitRenderer
        unitIndex={u.unitIndex}
        label={u.label}
        unit={unit}
        seats={u.seats}
        selectedSeat={selectedSeat}
        onSeatClick={onSeatClick}
        onSeatDrop={onSeatDrop}
      />
    </div>
  );
};

export default SingleArrangement;
